import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, shareReplay, switchMap } from "rxjs";
import { environment } from "../../environments/environment";
import { BaseService } from "./base.service";
import { FilterChip } from "../models/filter-chip";
import { Group } from "../models/group";

@Injectable({ providedIn: 'root' })
export class GroupsService extends BaseService {
    private sortProperties : { [key: string]: string } = {
        "key": "Key", "name" : "Name"
    };
    private groupsSubject = new BehaviorSubject<Group[]>([]);
    groups$ = this.groupsSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    fetchGroups() {
        this.http.get<Group[]>(environment.apiUrl + 'groups/search').subscribe(groups => {
            this.groupsSubject.next(groups);
        });
    }

    addGroup(newGroup: Group) {
        this.http.post(environment.apiUrl + 'groups', newGroup).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    updateGroup(updatedGroup: Group) {
        this.http.put(environment.apiUrl + `groups/${updatedGroup.id}`, updatedGroup).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    deleteGroup(group: Group) {
        this.http.delete(environment.apiUrl + `groups/${group.id}`).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    filterGroups(filters: FilterChip[], pageSize: number = 10, pageIndex: number = 0, sortField: string | undefined = undefined, sortDirection: string | undefined = undefined) {
        return this.sourceUpdatedSubject.pipe(
            switchMap(() => {
                const keywords = filters.filter(c => c.chip == null).reduce((v, c) => v + ' ' + c.value, '');
                const propertyValues = filters.reduce((v, c) => { if (c.chip != null) v[c.chip] = c.value; return v; }, <{ [key: string]: string }>{});
                const filter = <any>{ keywords, propertyValues };
                if (pageSize) filter['pageSize'] = ''+pageSize
                if (pageIndex) filter['page'] = ''+pageIndex;
                if (sortField) filter['SortSpecifications[0].Property'] = this.sortProperties[sortField];
                if (sortDirection) filter['SortSpecifications[0].Direction'] = sortDirection == "asc" ? "Ascending" : "Descending";

                const filterQuery = this.serialize(filter);
                return this.http.get<Group[]>(environment.apiUrl + 'groups/search?' + filterQuery, { observe: 'response' })
                    .pipe(
                        map(response => {
                            const paging = response.headers.get('Content-Range');
                            const total = parseInt(paging?.split("/")[1] ?? '0');
                            const groups = response.body ?? [];
                            return { total, groups };
                        }),
                        shareReplay()
                    );
            }));
        }
}